(ns hai.web-app.util.clipboard
  (:require [kitchen-async.promise :as p]))

(defn copy-to-clipboard
  "Copy text to clipboard"
  [text then]
  (-> js/navigator
      .-clipboard
      (.writeText text)
      (p/then then)
      (p/catch* js/console.error)))
